export default __webpack_public_path__ + "assets/images/blog-img.png";